<template>
  <div class="hidden justify-between sm:flex sm:w-8/12 md:pr-12" v-if="$can('manage', 'Geofences')">
    <div class="flex gap-2">
      <Button size="sm" variant="tertiary" @click="onEditClick">
        Edit
      </Button>
      <Button size="sm" variant="destructive" @click="onDeleteClick">
        Delete
      </Button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import GeofenceDetailsNavBar from './GeofenceDetailsNavBar.vue';
import { COMMON_DELETE_ERROR, COMMON_DELETE_SUCCESS } from '@/config/constants';

export default {
  components: { GeofenceDetailsNavBar },

  computed: {
    ...mapGetters({
      accountId: 'auth/accountId',
      geofenceById: 'geofence/byId',
    }),
    id() {
      return +this.$route.params.id;
    },
    geofence() {
      return this.geofenceById(this.id);
    },
  },

  methods: {
    ...mapActions({
      openModal: 'modal/open',
      delete: 'geofence/delete',
    }),
    onEditClick() {
      this.$router.push({
        name: 'GeofenceEditView',
        params: { id: this.$route.params.id },
      });
    },
    onDeleteClick() {
      this.openModal({
        name: 'CommonConfirmationModal',
        params: {
          actionLabel: 'Delete',
          title: this.geofence.name,
          body: 'Are you sure you want to delete this geofence?',
          onOk: () => this.delete({ accountId: this.accountId, id: this.id }),
          callback: () => this.$router.replace({ name: 'GeofenceListView' }),
          successMessage: COMMON_DELETE_SUCCESS,
          errorMessage: COMMON_DELETE_ERROR,
        },
      });
    },
  },
};
</script>
